import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/banner/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/banner/DomruBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
